import React from 'react'
import { SVGIconProps } from '../types'
const SvgChainBreak = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <g fill="#233745" fillRule="nonzero">
        <path d="m4.212 6.903.09 1.113a.4.4 0 0 1-.309.423l-.782.18a1.364 1.364 0 0 0 .53 2.672l.13-.026 3.528-.88a1.364 1.364 0 0 0 1.019-1.524l-.026-.129-.123-.494a.4.4 0 0 1 .291-.485l.988-.246a.4.4 0 0 1 .485.291l.123.494a3.18 3.18 0 0 1-2.149 3.81l-.168.047-3.529.88a3.18 3.18 0 0 1-3.857-2.317c-.41-1.649.686-3.39 2.15-3.81q1.219-.351 1.52-.149a.2.2 0 0 1 .089.15" />
        <path d="m9.108 6.693.053-.011c.337-.061.694.004.995.204l.106.078 2.826 2.288a1.364 1.364 0 0 1-1.61 2.197l-.738-.55a.3.3 0 0 0-.42.06l-.01.015q-.129.195-.313.44l-.078.099-.22.254c-.084.107-.085.176.01.393q.132.297.384.519l.135.106a3.182 3.182 0 0 0 4.137-4.832l-.133-.114-2.826-2.288a3.17 3.17 0 0 0-2.533-.665l-.226.047a.3.3 0 0 0-.227.296l.01.072.315 1.179a.3.3 0 0 0 .363.213" />
      </g>
      <g fill="#233745" transform="rotate(-12 9.257 -6.514)">
        <rect
          width={1.1}
          height={3}
          x={1}
          y={1}
          rx={0.55}
          transform="rotate(-38 1.55 2.5)"
        />
        <rect width={1} height={3} x={3} rx={0.5} />
        <path d="M6.432 1.286a.55.55 0 0 0-.769.122L4.547 2.945a.55.55 0 0 0 .89.647l1.116-1.537a.55.55 0 0 0-.121-.769" />
      </g>
    </g>
  </svg>
)
export default SvgChainBreak
